module.exports = __webpack_public_path__ + "static/media/utor_za_kotac.3472a22c.png";